import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { useSelector, useDispatch } from 'react-redux'
import { RootState } from '@/app/store'
import { urlregister } from '@/lib/custom'
import {
  CognitoUserPool,
  CognitoUser,
  AuthenticationDetails,
} from 'amazon-cognito-identity-js'
import awsConfiguration from '@/lib/awsconfiguration'
// import { removeLocalStorage } from '@/lib/removeLocalstorage'
import { availableState } from '@/features/authSlice'
import { dialogRegisterQuestionnaireState } from '@/features/dialogRegisterQuestionnaireSlice'
import { accountState, passwordState } from '@/features/accountSlice'

const userPool = new CognitoUserPool({
  UserPoolId: awsConfiguration.UserPoolId,
  ClientId: awsConfiguration.ClientId,
})

const useNoLogin = () => {
  const dispatch = useDispatch()
  const router = useRouter()

  const loginTypeStateSelector = useSelector(
    (loginTypeState: RootState) => loginTypeState.loginType.loginType
  )

  const accountSelector = useSelector(
    (accountState: RootState) => accountState.account.account
  )

  const NoLoginFunc = async () => {
    const cognitoRegisterFunc = await fetch(`${urlregister}`, {
      method: 'POST',
      headers: {
        'X-Raund-Token': `${process.env.NEXT_PUBLIC_RAUND_TOKEN}`,
      },
    })

    const result = await cognitoRegisterFunc.json()

    if (result.status === 200) {
      // ユーザー認証
      const authenticationDetails = new AuthenticationDetails({
        Username: result.username,
        Password: result.password,
      })

      dispatch(accountState(result.username))
      dispatch(passwordState(result.password))
      console.log(result)
      console.log(result)

      // ユーザープール

      // ユーザーを定義
      const cognitoUser = new CognitoUser({
        Username: result.username,
        Pool: userPool,
      })

      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: (result) => {
          const cognitoUser01 = userPool.getCurrentUser()
          cognitoUser01.getSession((err, session) => {
            if (err) {
              alert(err.message || JSON.stringify(err))
              return
            }
            // @ts-ignore
            window.session = session
            localStorage.setItem(
              `${process.env.NEXT_PUBLIC_SERVICE_NAME}-jwt`,
              session.getAccessToken().getJwtToken()
            )
            localStorage.setItem(
              `${process.env.NEXT_PUBLIC_SERVICE_NAME}-exp-token`,
              result.accessToken.payload.exp
            )

            dispatch(dialogRegisterQuestionnaireState(false))

            // if (
            //   router.pathname == '/auth/signin' ||
            //   router.pathname == '/auth/register'
            //   ) {
            //   location.href = `${process.env.NEXT_PUBLIC_SITEURL}/${process.env.NEXT_PUBLIC_SERVICE_NAME}/`
            // } else {
            //   dispatch(pageToggleState(true))
            // }
          })
        },
        onFailure: (err) => {
          console.log(err)
          dispatch(availableState(false))
        },
      })

      return
    }

    if (result.status === 400) {
      dispatch(availableState(false))
      return
    }
  }

  useEffect(() => {
    if (loginTypeStateSelector === 9) {
      const cognitoUser = userPool.getCurrentUser()
      try {
        if (
          !localStorage.getItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-jwt`)
        ) {
          console.log(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-jwt`)
          // localStorage.clear()
          // removeLocalStorage()
          if (cognitoUser !== null) {
            cognitoUser.signOut()
          }
          NoLoginFunc()
          return
        }
      } catch (error) {
        console.log(error)
      }
      return
    }
  }, [loginTypeStateSelector])
}

export default useNoLogin
